import { createSlice } from "@reduxjs/toolkit";

interface ModalState {
  isLogin: boolean;
  isRegister: boolean;
}

const initialState: ModalState = {
  isLogin: false,
  isRegister: false,
};

export const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    setIsLoginModal: (state: ModalState) => {
      state.isLogin = true;
      state.isRegister = false;
    },
    setIsRegisterModal: (state: ModalState) => {
      state.isRegister = true;
      state.isLogin = false;
    },
    setModalClose: (state: ModalState, action) => {
      if (action.payload === "login") {
        state.isLogin = false;
      } else if (action.payload === "register") {
        state.isRegister = false;
      } else {
        state.isLogin = false;
        state.isRegister = false;
      }
    },
  },
});

export const { setIsLoginModal, setIsRegisterModal, setModalClose } =
  modalSlice.actions;
export default modalSlice.reducer;
